import { render, staticRenderFns } from "./StavkeServisneOperacije.vue?vue&type=template&id=604f3e67&scoped=true&"
import script from "./StavkeServisneOperacije.vue?vue&type=script&lang=ts&"
export * from "./StavkeServisneOperacije.vue?vue&type=script&lang=ts&"
import style0 from "./StavkeServisneOperacije.vue?vue&type=style&index=0&id=604f3e67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604f3e67",
  null
  
)

export default component.exports